import React from "react";
import Tooltip from "@mui/material/Tooltip";

function PortfolioItem({ image, description, alt, title }) {
  return (
    <li>
      <div className="inner">
        <div className="entry tokyo_tm_portfolio_animation_wrap">
          <Tooltip title={alt} followCursor>
            <img
              src={image}
              width="300"
              height="300"
              decoding="async"
              data-nimg="1"
              loading="lazy"
              style={{ color: "transparent" }}
              currentitem="false"
              alt={alt}
            />
          </Tooltip>
        </div>
      </div>
    </li>
  );
}

export default PortfolioItem;
